module.exports = __webpack_public_path__ + "static/media/settings-6.b8c67c19.svg";